import { useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

const loadedScripts = new Set<string>();

export const useThirdPartyScript = (content: string) => {
    const scriptRef = useRef(uuidv4());
    const containerIdRef = useRef(`script-container-${scriptRef.current}`);

    useEffect(() => {
        if (!content || !content.includes('<script')) {
            return;
        }

        const re = /<(script[^>]*)>([\s\S]*?)<\/script>/gm;
        let match: any[] | null;
        const importedScripts: Element[] = [];
        const scriptUrls: string[] = [];

        while ((match = re.exec(content))) {
            const reSrc = /src="(.*?)"/gm;
            const src = reSrc.exec(match[1]);

            if (src && src[1]) {
                const scriptUrl = src[1];
                scriptUrls.push(scriptUrl);

                // Vérifier si ce script est déjà chargé
                if (loadedScripts.has(scriptUrl)) {
                    console.log(`Script déjà chargé: ${scriptUrl}`);
                    continue;
                }

                const script = document.createElement('script');
                script.src = scriptUrl;
                script.setAttribute('data-script-url', scriptUrl);
                
                const container = document.getElementById(containerIdRef.current);
                if (container) {
                    container.appendChild(script);
                    importedScripts.push(script);
                    loadedScripts.add(scriptUrl);
                }
            } else {
                // Pour les scripts inline, on les exécute avec un délai
                const script = document.createElement('script');
                const scriptContent = match[2];
                script.textContent = `
                    setTimeout(function() {
                        try {
                            ${scriptContent}
                        } catch(e) {
                            console.warn('Erreur script inline:', e);
                        }
                    }, 1000);
                `;
                
                
                const container = document.getElementById(containerIdRef.current);
                if (container) {
                    try {
                        container.appendChild(script);
                        importedScripts.push(script);
                    } catch (e) {
                        console.error('Erreur lors de l\'ajout du script:', e);
                    }
                }
            }
        }

        // Cleanup
        return () => {
            importedScripts.forEach((script) => {
                const container = document.getElementById(containerIdRef.current);
                if (container && script.parentNode === container) {
                    try {
                        container.removeChild(script);
                    } catch (e) {
                        console.warn('Erreur lors du nettoyage du script:', e);
                    }
                }
            });
        };
    }, [content]);

    return containerIdRef.current;
};